import { 
    CREATE_RE_PROCESSING,
    FETCH_ALL_REPROCESSING,
    DELETE_REPROCESSING,
    ADD_ALERT,
    ADD_REPROCESSING_TO_CARDETAIL
} from './types';
import shortId from "shortid";
import sleektrading from "../apis/sleektrading"

export const createReProcessing = (values) => dispatch => {
    sleektrading.post('/reprocessings', values)
        .then(response => {
            if(response.data.code == 201) {
                dispatch({
                    type:ADD_REPROCESSING_TO_CARDETAIL,
                    payload:response.data.data,
                });
                dispatch({
                    type: ADD_ALERT,
                    payload: {
                        key: shortId.generate(),
                        status: 'success',
                        color:'info',
                        message: response.data.message,
                        errors: {}
                    }
                });
            } else {
                dispatch({
                    type: ADD_ALERT,
                    payload: {
                        key: shortId.generate(),
                        status: 'success',
                        color:'info',
                        message: response.data.message,
                        errors: {}
                    }
                });
            }
    }).catch(error => {
        dispatch({
                type:ADD_ALERT,
                payload:{
                key:shortId.generate(),
                status:'error',
                message:error.response.data.message,
                errors:error.response.data.errors
            }
        });
    });
}

export const fetchAllReProcessings= () => async dispatch => {
    const {data} = await sleektrading.get(`/reprocessings`);
    
    if(data.code == 201){
        dispatch({
            type: FETCH_ALL_REPROCESSING,
            payload: data.data
        });
    }
}

export const printReProcessing = (params) => dispatch => {
    const config = { responseType: 'blob', Accept:'application/pdf' };   
    sleektrading.post('/reprocessings/print', params, config)
    .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const date = new Date().getTime()+'reprocessing.pdf';
        link.setAttribute('download', date);
        document.body.appendChild(link);
        link.click();
        const blob = new Blob([response.data], {
            type: "application/pdf",
        });
    });
    
}

export const deleteReProcessing= (reprocessing) => async dispatch => {
    sleektrading.delete(`/reprocessings/${reprocessing}`)
    .then(response => {
        if(response.data.code == 200) {
            dispatch({
                type:DELETE_REPROCESSING, 
                payload:reprocessing
            });
            dispatch({
                type: ADD_ALERT,
                payload: {
                    key: shortId.generate(),
                    status: 'success',
                    color:'info',
                    message: response.data.message,
                    errors: {}
                }
            });
        } else {
            dispatch({
                type: ADD_ALERT,
                payload: {
                    key: shortId.generate(),
                    status: 'success',
                    color:'info',
                    message: response.data.message,
                    errors: {}
                }
            });
        }
    }).catch(error => {
        dispatch({
            type:ADD_ALERT,
            payload:{
            key:shortId.generate(),
            status:'error',
            message:error.response.data.message,
            errors:error.response.data.errors
        }
    });
    });
}



